// extracted by mini-css-extract-plugin
export var root = "TeachAndLearnBlock-module--root--21F95";
export var grid = "TeachAndLearnBlock-module--grid--3Wrc9";
export var logo = "TeachAndLearnBlock-module--logo--dAxdj";
export var rocks = "TeachAndLearnBlock-module--rocks--1f5CW";